import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { AppConfig } from '../../app.config';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Facility } from '../models/facility';
import { Reading, Group, PasswordVars } from '../index';
import { PccReadingStatus } from '../models/pcc-reading-status';
import { Patient } from '../models/patient';
import { DashboardReadingBreachCount } from '../models/dashboard';

@Injectable()
export class FacilitiesService {

    constructor(private http: Http, private config: AppConfig) { }

    getAll(): Observable<Facility[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/facilities', { headers })
            .pipe(map((response: Response) => { return <Facility[]>response.json();
            }),catchError(this.handleError))
    }

    getUserFacilities(): Observable<Facility[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/facilities/userfacilities', { headers })
            .pipe(map((response: Response) => {
                return <Facility[]>response.json();
            }),catchError(this.handleError))
    }

    getFacilityGroups(id): Observable<Group[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/facilities/' + id + '/groups', { headers })
            .pipe(map((response: Response) => {
                return <Group[]>response.json();
            }),catchError(this.handleError))
    }

    getFacilityReadings(id,groupid, startDate,endDate, breachOnly, todayOnly): Observable<Reading[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/facilities/' + id+"/readings"
            + '?groupId=' + groupid
            + '&breachOnly=' + breachOnly
            + '&startDate=' + startDate
            + '&todayOnly=' + todayOnly
            + '&endDate=' + endDate, { headers })
            .pipe(map((response: Response) => {
                return <Reading[]>response.json();
            }),catchError(this.handleError))
    }

    getPasswordCriteria(facilityId): Observable<PasswordVars> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/facilities/' + facilityId + '/passwordRegx', { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <PasswordVars>response.json();
            }),catchError(this.handleError))
    }

    getPasswordCriteriaForSelectedFacilities(facilityNames): Observable<PasswordVars> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/facilities/facilitiesPasswordRegx', JSON.stringify(facilityNames ), { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <PasswordVars>response.json();
            }),catchError(this.handleError))
    }


    getReadingStatus(id): Observable<PccReadingStatus> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/readings/' + id + '/pccstatus', { headers })
            .pipe(map((response: Response) => {
                return <PccReadingStatus>response.json();
            }),catchError(this.handleError))
    }


    postReadingToPcc(id): Observable<boolean> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/readings/' + id + '/posttopcc', {}, { headers })
            .pipe(map((response: Response) => {
                return <boolean>response.json();
            }),catchError(this.handleError))
    }

    getFacility(id): Observable<Facility> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/facilities/' +id, { headers })
            .pipe(map((response: Response) => {return <Facility>response.json()}),catchError(this.handleError))
    }

    getPatients(facilityId, isActive): Observable<Patient[]> {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/facilities/' + facilityId + "/patients?isActive=" + isActive, { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return <Patient[]>response.json();
            }),catchError(this.handleError))
    }

    getPatientsImages(facilityId): Observable<any> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/facilities/' + facilityId + "/patientsimages", { headers })
            .pipe(map((response: Response) => {
                return response.json();
            }),catchError(this.handleError))
    }

    getTodaysPatientsReadingsStats(facilityId): Observable<DashboardReadingBreachCount[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);

        //console.log(currentUser.auth_token);


        return this.http.get(this.config.apiUrl + "/api/facilities/" + facilityId +"/patientstats?todayOnly="+true, { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return response.json();
            }), catchError(this.handleError))


    }


    getTodaysUserUsageStats(facilityId): Observable<DashboardReadingBreachCount[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);

        return this.http.get(this.config.apiUrl + "/api/facilities/" + facilityId + "/userstats?todayOnly="+ true, { headers })
            .pipe(map((response: Response) => {
                //console.log(response);
                return response.json();
            }), catchError(this.handleError))


    }


    getTodaysFacilityReadings(id, groupid, breachOnly): Observable<Reading[]> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.get(this.config.apiUrl + '/api/facilities/' + id + "/readings"
            + '?breachOnly=' + breachOnly
            + '&todayOnly=' + true
            , { headers })
            .pipe(map((response: Response) => {
                return <Reading[]>response.json();
            }),catchError(this.handleError))
    }

    getBreachesFromReadings(allReadings): Observable<Reading[]> {

        let breaches = allReadings
            .map(reading => {
                if (reading.isBreach) {
                    //console.log(reading);
                    return reading;
                }
            });
        return breaches;
    }

    createFacility(facility): Observable<Facility> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/facilities/createfacility', facility, { headers }).pipe(map((response: Response) => {
            //console.log(response);
            return <Facility>response.json();
        }),catchError(this.handleError))
    }

    updateFacility(facility): Observable<Facility> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/facilities/updatefacility', facility, { headers }).pipe(map((response: Response) => {
            //console.log(response);
            return <Facility>response.json();
        }),catchError(this.handleError))
    }

    deactivateFacility(facility): Observable<Facility> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/facilities/deactivate', facility, { headers }).pipe(map((response: Response) => {
            //console.log(response);
            return <Facility>response.json();
        }),catchError(this.handleError))
    }


    assignUsersToAllGroups(facility): Observable<any> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/facilities/' + facility.id + "/assignalluserstoallgroups", facility, { headers }).pipe(map((response: Response) => {
            console.log(response.json());
            return response.json();
        }),catchError(this.handleError))
    }

    restoreFacilityDefaultThresholdSettings(facility): Observable<any> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/facilities/' + facility.id + "/restoreDefaultThresholdSettings", facility, { headers }).pipe(map((response: Response) => {
            console.log(response.json());
            return response.json();
        }), catchError(this.handleError))
    }

    applyThresholdSettingsToAllPatients(facility): Observable<any> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let authToken = currentUser.auth_token;
        let headers = new Headers();

        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + authToken);
        return this.http.post(this.config.apiUrl + '/api/facilities/' + facility.id + "/applyThresholdSettingsToAllPatients", facility, { headers }).pipe(map((response: Response) => {
            console.log(response.json());
            return response.json();
        }), catchError(this.handleError))
    }



    // private helper methods
    private handleError(error: Response) {
        //console.log(error);
        return Observable.throw(error.statusText);
    }

    private jwt() {
        // create authorization header with jwt token
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
            return new RequestOptions({ headers: headers });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/facilities.service.ts